<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <circle cx="10" cy="10" r="10" fill="#2E8B6E" />
  <path d="M5.75 10.25L8.5 13L14.25 7.25" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
</svg>
